<template>
  <div class="flex column">
    <HeaderCard :title="$t('left-menu.blogs')" @open="openBlogEditor" :btnTitle="$t('CMSBlog.addPost')"></HeaderCard>
    <el-row class="mb-10 mt-0">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
        <span v-if="selected.length==0 && !isFiltered" class="fs-14">{{$t('CMSBlog.allPosts')}} <span><el-button icon="el-icon-plus" circle size="small" @click="openBlogEditor"></el-button></span></span>
        <span v-else>
          <span class="fs-14">{{$t('CMSBlog.posts')}}</span>
          <span v-if="!isFiltered">
            <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> {{$t('CMSBlog.selected')}}</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{selected.length}}</span>
            <el-dropdown size="small" split-button type="primary" class="ml-20">
              {{$t('CMSBlog.actions')}}
              <el-dropdown-menu slot="dropdown">
               <el-dropdown-item @click.native="deleteSelectedBlogs"><i class="el-icon-delete"></i>{{$t('CMSBlog.delete')}}</el-dropdown-item>
               <el-dropdown-item :disabled="true"><i class="mdi mdi-file-excel"></i>{{$t('CMSBlog.exportCSV')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <span v-else>
            <span class="mr-10 fs-14"><i class="el-icon-arrow-right"></i> {{$t('CMSBlog.searchResults')}}</span><span class="bg-accent-lighter b-rad-18 p-8 fs-14">{{cmsBlogs.length}}</span>
          </span>
        </span>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
        <el-input
          :placeholder="$t('CMSBlog.searchPost')"
          clearable
          size="small"
          v-model="searchModel"
          v-popover:popover>
          <!-- <el-dropdown slot="append" style="border-right:1px;">
              <el-button type="primary">
              Trier par<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :icon="sortIcon('customer.name')" @click.native="sortBy('customer.name')">Client</el-dropdown-item>
              <el-dropdown-item :icon="sortIcon('inv_number')" @click.native="sortBy('inv_number')">Numéro de facture</el-dropdown-item>
              <el-dropdown-item  :icon="sortIcon('updated_at')" @click.native="sortBy('updated_at')">Dernière modification</el-dropdown-item>
              <el-dropdown-item  :icon="sortIcon('date')" @click.native="sortBy('date')">Date de facturation</el-dropdown-item>
              <el-dropdown-item  :icon="sortIcon('paid_at')" @click.native="sortBy('paid_at')">Date de paiement</el-dropdown-item>
              </el-dropdown-menu>
          </el-dropdown> -->
          <!-- <el-button slot="prepend" @click="showFilters=true"><i class="mdi mdi-filter-variant" style="font-size:15px;"></i></el-button> -->
        </el-input>
      </el-col>
    </el-row>
    <div class="flex center m-10">
      <Pagination
        class="box right mt-5 mb-0 fs-14 secondary-text"
        :current-page="currentPage"
        :total-number-of-page="totalPages"
        @click-previous="fetchPreviousPage"
        @click-next="fetchNextPage" />
    </div>
    <el-table
      :data="cmsBlogs"
      stripe
      @selection-change="handleSelectionChange"
      :empty-text="$t('CMSBlog.empty')"
      height="100%"
      v-loading="loading"
      :style="'width:' + getTableWidth  + 'px'">
    <el-table-column
      type="selection"
      fixed="left"
      width="55">
    </el-table-column>
    <el-table-column
      prop="title"
      width="400"
      fixed="left"
      :label="$t('CMSBlog.blog.title')">
      <template slot-scope="scope">
        <PortausLink :id="scope.row.id" path="/settings/CMS/blogs/" :label="scope.row.title[lang]"></PortausLink>
      </template>
    </el-table-column>
    <el-table-column
      :label="$t('CMSBlog.blog.type')">
      <template slot-scope="scope">
        <span v-if="scope.row.type != null">{{scope.row.type.name}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="mainImage"
      resizable
      align="center"
      :label="$t('CMSBlog.blog.mainImage')">
      <template slot-scope="scope">
        <span v-if="mainImageExists(scope.row.mainImage)">
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover">
            <slot name="content">
              <div class="text-center">
                <el-image
                  :src="scope.row.mainImage.thumbnailLink"
                  fit="contain">
                </el-image>
              </div>
            </slot>
            <i slot="reference" class="fs-18 accent-text mdi mdi-image-search-outline"> </i>
          </el-popover>
        </span>
      </template>
    </el-table-column>
    <el-table-column
      prop="images"
      resizable
      align="center"
      :label="$t('CMSBlog.blog.galeries')">
      <template slot-scope="scope">
        <span v-if="galerieExists(scope.row.images)">
          <i slot="reference" class="fs-18 mdi mdi-image-multiple-outline"> </i>
        </span>
      </template>
    </el-table-column>
    <el-table-column
      prop="name"
      :label="$t('CMSBlog.blog.author')">
      <template slot-scope="scope">
        <span v-if="scope.row.user">{{scope.row.user.firstName}} {{scope.row.user.lastName}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="published"
      resizable
      align="center"
      :label="$t('CMSBlog.blog.published')">
      <template slot-scope="scope">
        <i v-if="scope.row.published" class="accent-text el-icon-success"></i>
        <i v-else class="el-icon-error"></i>
      </template>
    </el-table-column>
    <el-table-column
      prop="publishedDate"
      resizable
      align="center"
      :label="$t('CMSBlog.blog.publishedDate')">
      <template slot-scope="scope">
        <span v-if="scope.row.published">
          {{_moment(scope.row.publishedDate)}}
        </span>
      </template>
    </el-table-column>
  </el-table>
  </div>
</template>
<script>
import cmsAPI from '@/services/API/cmsAPI'
import HeaderCard from '@/components/header-card'
// import Blog from './blog'
import moment from 'moment-timezone'
import PortausLink from '@/components/portaus-link'
import Promise from 'bluebird'
import Pagination from '@/components/pagination'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	name: 'Blogs',
	data() {
		return {
      selected: [],
      cmsBlogs : [],
      loading: false,
      search: '',
      currentPage : 1,
      totalPages : 0,
      totalBlog: 0,
      limit:50,
      outdated: false,
      searchTimer: null,
      window: {
        width: 0,
        height: 0
      },
		}
	},
  components: {
    HeaderCard,
    PortausLink,
    Pagination,
  },
  watch : {
    lang(newLang, oldLang) {
      this.refreshBlogs();
    }
  },
  computed: {
    searchModel : {
      set(val){ this.setSearch(val)},
      get(){return this.search; }
    },
    isFiltered () {
      return false;
    },
    lang(){
      return this.$i18n.locale
    },
    ...mapGetters(['getLocale']),
  },
  methods : {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getTableWidth() {
      return (this.window.width-320);
    },
    setSearch (t) {
      clearTimeout(this.searchTimer);
      this.search = t;
      this.searchTimer = setTimeout(() => {
        this.currentPage = 1;
        this.outDated = true;
        this.refreshBlogs();
      }, 500);

    },
    fetchNextPage () {
      if (this.currentPage < this.totalPages) {
        this.currentPage = this.currentPage + 1;
        this.outdated = true;
        this.refreshBlogs();
      }
    },
    fetchPreviousPage () {
      if (this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
        this.outdated = true;
        this.refreshBlogs();
      }
    },
    buildParams () {
      return {
        t: this.search,
        page: this.currentPage,
        detailed: false,
      }
    },
    fetchCMSBlogs () {

      if (this.searchModel != null && this.searchModel !== '') {
        this.currentPage = 1;
      }

      const params = this.buildParams();

      this.loading = true;
      cmsAPI.fetchCMSBlogs(params, this.getLocale)
        .then((blogs) => {
          this.loading = false;
          this.cmsBlogs = blogs.list;
          this.totalBlog = blogs.count;
          this.totalPages = blogs.pages;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(this.$i18n.t('common.errors.generic'));
        })
    },
    // logoExists(images) {
    //   let exists = false;
    //   _.forEach(images, img => {
    //     if (img.isProviderLogo) {
    //       exists = true;
    //     }
    //   })
    //   return exists;
    // },
    galerieExists (images) {
      return _.size(images) > 0;
    },
    mainImageExists(mainImage) {
      return mainImage != null;
    },
    deleteSelectedBlogs(){
      this.$confirm('Êtes vous sûr de vouloir supprimer les articles sélectionnés?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        }).then(()=>{
          return Promise.each(this.selected, p=>{
            return cmsAPI.deleteBlog(p.id);
          }).then(()=>this.refreshBlogs())
        }).catch(err=>{
          if(err=="cancel"){
            this.$message('Suppression annulée!');
          }else{
            console.log(err);
            this.$message.error('Une erreur est survenue. Veuillez réessayer plus tard');
          }
        })
    },
    _moment(datetime, format='l'){
      return moment(datetime).format(format);
		},
    openBlogEditor(){
      this.$router.push('/settings/CMS/blog');
    },
    refreshBlogs(){
      this.fetchCMSBlogs();
    },
    handleSelectionChange(val){
      this.selected = val;
    },
    // ...mapActions('cmsProviders',['fetchCMSProviders','setSearch', 'fetchPreviousPage', 'fetchNextPage'])
  },
  mounted(){
    this.fetchCMSBlogs();
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';


</style>
